import {truncateNumber} from "../../../../Utils/NumberUtil";

export const NO_DATA = "-";
/** Mesma string usada por AProgressTotalizer.NO_PERCENTAGE, para consistência visual. */
export const NO_DATA_PERCENTAGE = "- %";

/**
 * SGD-3680: só a ausência de dado é exibida como "-". Zero é uma medição válida e
 * continua sendo exibido como 0 — o backend retorna null quando não há dado no período.
 */
export const hasExpectedData = (expected: number | null | undefined): boolean =>
    expected != null && Number.isFinite(expected);

/**
 * O percentual medido/esperado só existe com esperado maior que zero: dividir por zero
 * é indefinido, então o valor esperado aparece como 0 mas o percentual como "- %".
 */
export const canCalculatePercentage = (expected: number | null | undefined): boolean =>
    hasExpectedData(expected) && (expected as number) > 0;

export const formatMeasuredValue = (value: number | null | undefined): number | string =>
    value == null ? NO_DATA : (truncateNumber(value, 2) ?? NO_DATA);

/** Valores do sinóptico vêm em kWh / Wh/m² e são exibidos em MWh / kWh/m². */
export const formatValueToMega = (value: number | null | undefined): number | string =>
    value == null ? NO_DATA : (truncateNumber(value / 1000, 2) ?? NO_DATA);

/**
 * Percentual medido/esperado, limitado a 100. Retorna null quando o percentual não é
 * calculável — cabe ao chamador traduzir isso para NO_DATA_PERCENTAGE.
 */
export const calculateProgress = (
    value: number | null | undefined,
    expected: number | null | undefined
): number | null => {
    if (value == null || !canCalculatePercentage(expected)) {
        return null;
    }
    return truncateNumber(Math.min(100, Math.round((value / (expected as number)) * 100)), 2);
};
